import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import { getCities } from '../../ApiServices/CityStateServices';
import { t } from 'i18next';

export const initialState = {
  value: { totalCount: -1, data: [{}] },
  loading: false,
  error: null,
  rowsPerPage: 10,
  pageNo: 0,
  selectedValue: null,
  sortBy: '',
  sortDirection: 0,
  filter: [{}]
};

const citiesSlice = createSlice({
  name: 'cities',
  initialState: initialState,
  reducers: {
    clearCitiesState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.filter = initialState.filter;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchCities.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value.data = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
      state.sortBy = action?.meta?.arg?.sortBy;
      state.sortDirection = action?.meta?.arg?.sortDirection;
      state.filter = action.meta.arg.filter;
    });
    builder.addCase(fetchCities.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error?.message;
      state.loading = false;
      state.selectedValue = initialState?.selectedValue;
    });
  }
});

export const citiesState = (state: RootState) => state?.cities;
export const { clearCitiesState } = citiesSlice.actions;
export default citiesSlice.reducer;

export const fetchCities = createAsyncThunk(
  'cities/fetchCities',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_CITIES') }));
      return fulfillWithValue(await getCities(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
